import { Injectable } from '@angular/core'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import {
  AutomationDocumentFormData,
  AutomationDocumentFormDialogComponent,
} from './automation-document-form-dialog.component'
import { AutomationViewGroup } from '@tokeet-frontend/automations'

@Injectable()
export class AutomationDocumentFormDialogService {
  constructor(private dialog: DialogService) {}

  open(automation?: AutomationViewGroup) {
    return this.dialog.openFixedDialog<AutomationDocumentFormDialogComponent, AutomationDocumentFormData>(
      AutomationDocumentFormDialogComponent,
      {
        width: '600px',
        data: { automation },
      }
    )
  }
}
